import _ from 'lodash';
// 外部各行业逾期情况
export const outsideColumnsConfig = {
    height: '500px',
    columns: [{
        label: '客户编码',
        prop: 'customerCode'
    }, {
        label: '客户名称',
        prop: 'customerName'
    }, {
        label: '客户系名称',
        prop: 'customerGroupName'
    }, {
        label: '客户等级',
        prop: 'customerLevelName'
    }, {
        label: '应收账款',
        prop: 'arAmt'
    }, {
        label: '本月到期',
        prop: 'amtDue'
    }, {
        label: '逾期账款',
        prop: 'amtOverdue'
    }, {
        label: '逾期率',
        prop: 'overdueRate'
    }, {
        label: '风险计提',
        prop: 'riskAccrual'
    }, {
        label: '专业公司',
        prop: 'professionalCompanyName'
    }, {
        label: '行业大类',
        prop: 'industryBigTypeName'
    }, {
        label: '片区',
        prop: 'areaName'
    }, {
        label: '运作分公司',
        prop: 'companyName'
    }, {
        label: '逾期30天内',
        prop: 'amtOverdue30Day'
    }, {
        label: '逾期30-90天',
        prop: 'amtOverdue30T90Day'
    }, {
        label: '逾期90-180天',
        prop: 'amtOverdue90T180Day'
    }, {
        label: '逾期180天以上',
        prop: 'amtOverdue180Day'
    }]
};
export const searchListConfig = [
    {
        prop: 'ebcdCode',
        name: '专业公司',
        type: 'select',
        placeholder: '请选择专业公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-overdue-search-ebcdCode'
    },
    {
        prop: 'industryCategory',
        name: '行业大类',
        type: 'cascader',
        props: {
            multiple: true,
            value: 'code',
            label: 'name'
        },
        placeholder: '请选择行业大类',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-overdue-search-industryCategory'
    },
    {
        prop: 'areaCode',
        name: '片区',
        type: 'select',
        placeholder: '请选择片区',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-overdue-search-areaCode'
    },
    {
        prop: 'subBranchCode',
        name: '分公司',
        type: 'select',
        placeholder: '请选择分公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-sub-personal-overdue-search-subBranchCode'
    },
    // {
    //     prop: 'businessCode',
    //     name: '业务场景',
    //     type: 'select',
    //     placeholder: '请选择业务场景',
    //     multiple: true,
    //     optionsKey: ''
    // },
    // {
    //     prop: 'bigEbcdName',
    //     name: '大专司',
    //     type: 'select',
    //     placeholder: '请选择大专司',
    //     multiple: false,
    //     defaultValue: '整体',
    //     options: [
    //         {
    //             code: '整体',
    //             name: '整体'
    //         },
    //         {
    //             code: '城配送装',
    //             name: '城配送装'
    //         },
    //         {
    //             code: '零担干线',
    //             name: '零担干线'
    //         },
    //         {
    //             code: '生产物流',
    //             name: '生产物流'
    //         },
    //         {
    //             code: '非专司',
    //             name: '非专司'
    //         }
    //     ]
    // },
    {
        prop: 'customerlevelName',
        name: '客户等级',
        type: 'radio',
        placeholder: '请选择客户等级',
        fixed: 'left',
        className: 'bigData-btn-home-sub-personal-overdue-search-customerlevelName'
    },
    {
        prop: 'timeStatus',
        name: '时间',
        type: 'time',
        placeholder: '请选择时间',
        fixed: 'left',
        className: 'bigData-btn-home-sub-personal-overdue-search-timeStatus'
    }
];
export const updateTimeBigdataList = {
    resetClassName: 'bigData-btn-home-sub-personal-overdue-reset',
    closeClassName: 'bigData-btn-home-sub-personal-overdue-close'
};
